import { InjectionToken } from "@angular/core";

export const TRANSLATION_PREFIX = "multi-session-limit";
export const NOT_SET_TRANSLATION_KEY = `${TRANSLATION_PREFIX}.placeholder`;

export const MAX_TIME_LIMITS = {
	daily: 24,
	weekly: 168,
	monthly: 720,
};
export interface SessionLimitConfig {
	monthlySessionLimitNotRequired?: boolean;
}

export const SESSION_LIMIT_CONFIG = new InjectionToken<SessionLimitConfig>("SessionLimitConfig");

export const enum MultiSessionLimitType {
	Current = "current",
	Upcoming = "upcoming",
}
